module.exports = __webpack_public_path__ + "static/media/soccer-arch.de986f13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/PlayGround/soccer-arch.svg
// module id = 1126
// module chunks = 0